import styled from 'styled-components';

export const StyledTitle = styled.h1`
  margin-top: 0;
  padding-top: 24px;
`;

export const StyledLink = styled.a`
  color: #25c2a0;
`;

export const StyledListItem = styled.li`
  text-align: justify;
`;

export const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
  /* margin-top: 16px;
  margin-bottom: 16px; */
`;


export const StyledQrImage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledImage = styled.img`
  width: 350px;
  max-height: 600px;
  min-height: 320px;
  margin-bottom: 8px;
`;
